import React from "react";
import { StyleSheet, View } from "react-native";
import { MediaContentCarosel } from "../components/MediaContentCarosel";
import { TemplateProps } from "../../types";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { useComponent } from "../providers/ConfigProvider";

const makeStyles = (theme: ThemeOptions) =>
  StyleSheet.create({
    page: {
      backgroundColor: theme.background,
      flex: 1,
    },
  });

export const MediaOnly = ({ onLoopComplete }: TemplateProps) => {
  const theme = useTheme();
  const styles = makeStyles(theme);
  const component = useComponent("media", "media_content");

  return (
    <View style={styles.page}>
      <MediaContentCarosel
        backgroundColor={theme.background}
        onLoopComplete={onLoopComplete}
        data={component ?? []}
      />
    </View>
  );
};
